function normalize (path) {
    return path.replace(/\/+$/, '') || '/'
}

/**
 * Whether a navigation item is the current page, or (unless `exact`) the section it belongs to.
 * A parent counts as current when you're on one of its children.
 */
export function isCurrent (item, exact = false) {
    const current = normalize(window.location.pathname)
    const paths = [item.url, item.button?.url, ...(item.children ?? []).map(child => child.url)]
        .filter(Boolean)
        .map(url => normalize(new URL(url, window.location.origin).pathname))

    if (exact) {
        return paths[0] === current
    }

    return paths.some(path => path !== '/' && (current === path || current.startsWith(`${path}/`)))
}
